module.exports = __webpack_public_path__ + "img/part-5-title.9244a2d9.png";